import { postJson } from '../api/client';

export type PartnerUploadedImage = {
  mediaId: string;
  imageUrl: string;
  ownershipTicket: string;
};

/**
 * 파트너 콘솔 이미지 업로드 공용 경로: grant 발급 → S3 PUT → commit.
 * 반환값 { mediaId, imageUrl, ownershipTicket } 은 studio primary/gallery,
 * room imageTickets 요청 body 에 그대로 넣는다.
 *
 * targetType/ownerType 은 백엔드 media enum 그대로 — 종전 'STUDIO_IMAGE'/
 * 'ROOM_IMAGE' + ownerType USER 는 서버에 없는 값이라 모든 업로드가 400
 * 이었다 (2026-08-25, Flutter 앱 실사용 값으로 정정). 룸은 등록 경로가
 * PRIMARY 티켓을 안 받아(403 SPACE-MEDIA-005) 전부 GALLERY, 대표는 목록
 * 첫 장 규약.
 */
export async function uploadPartnerImage(
  file: File,
  opts: {
    targetType:
      | 'STUDIO_PRIMARY_IMAGE'
      | 'STUDIO_GALLERY_IMAGE'
      | 'ROOM_GALLERY_IMAGE';
    studioId: string;
  },
): Promise<PartnerUploadedImage> {
  const { prepareImageForUpload, putAndCommit } = await import('../api/media');
  const uploadFile = await prepareImageForUpload(file);
  const grant = await postJson<{
    mediaRef: string;
    uploadUrl: string;
    publicUrl: string;
    uploadHeaders?: Record<string, string>;
    ownershipTicket?: string;
  }>('/api/v1/media/uploads', {
    contentLength: uploadFile.size,
    contentType: uploadFile.type,
    fileName: uploadFile.name,
    ownerKey: opts.studioId,
    ownerType: 'STUDIO',
    targetType: opts.targetType,
  });
  const committed = await putAndCommit({
    mediaId: grant.mediaRef,
    uploadUrl: grant.uploadUrl,
    uploadHeaders: grant.uploadHeaders,
    ownershipTicket: grant.ownershipTicket,
    file: uploadFile,
  });
  return {
    mediaId: committed.mediaId,
    imageUrl: grant.publicUrl ?? '',
    ownershipTicket: committed.ownershipTicket,
  };
}
